import { combineReducers } from "redux";
import auth from "../auth/reducers";

const createRootReducer = () =>
  combineReducers({
    auth,
  });

export default createRootReducer;
